<template>
    <div>
        <el-table class="news-table" :data="newsList" :row-key="() => Math.random()">
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="_hotType" label="Hot"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" circle icon="el-icon-edit" @click="handleUpdate(scope.row)"></el-button>
                    <el-button type="danger" circle icon="el-icon-delete" @click="handleRemove(scope.row.id)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'newsList',
        props:['language'],
        data() {
            return {
                sortable: '.news-table',
                pushInfo: {
                    titleZh : '',
                    titleEn : '',
                    contentZh: '',
                    contentEn:'',
                    pushNo: '',
                    jumpUrl: ''
                },
            };
        },
        computed: {
            ...mapGetters('newsSetting', ['newsList'])
        },
        methods: {
            ...mapMutations('newsSetting', ['toggleDetailDialogVisible']),
            ...mapActions('newsSetting', ['list', 'remove','push','setDetail','buildOpType']),
            handleUpdate(data) {
                this.setDetail(data);
                this.buildOpType('update');
                this.$router.push({ path: '/home/setting/news/editor' });
            },
            handleRemove(id) {
                this.$confirm('确认删除此快讯吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.remove(id).then(() => {
                            this.$message.success('删除成功！');
                            this.$emit('refresh');
                        });
                    })
                    .catch(() => {
                    });
            },
            refreshList() {
                this.$emit('refresh');
            },
        }
    };
</script>

<style lang="less" scoped>
</style>
